import React from 'react';

type Props = {
    children: any;
};

const ChartHighlight = (props: Props) => <p dangerouslySetInnerHTML={{ __html: props.children }} />;

export default ChartHighlight;
